import { handleActions } from 'redux-actions';

const INITIAL_STATE = {
  loading: false,
  login_modal_open: false,
  login_modal_title: '',
  loading_text: 'Fetching...',
};

/**
 * Application props via this.props.appstate in connected components
 */
const applicationState = handleActions(
  {
    UPDATE_APP_STATE: (state, action) => Object.assign({}, state, action.payload),
  },
  INITIAL_STATE,
);

export default applicationState;



// WEBPACK FOOTER //
// ./src/reducers/applicationState.js